import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/estados-participante`;

export async function getEstadosParticipante() {
  const { data } = await axios.get(baseUrl);
  return data;
}

export async function getEstadoParticipanteById(id) {
  if (!id) return { success: false, data: null };
  const { data } = await axios.get(`${baseUrl}/${id}`);
  return data;
}

export async function getEstadoParticipanteByCodigo(codigo) {
  if (!codigo) return { success: false, data: null };
  const { data } = await axios.get(`${baseUrl}/codigo/${codigo}`);
  return data;
}
